import { NotFoundContent } from '../../components/not-found-content';

export default function NotFoundFeature() {
  return <NotFoundContent />;
}
